import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

//Material UI imports:
import 'typeface-roboto';

ReactDOM.render(<App />, document.getElementById('root'));